// common for RateTable component and App
export default {
    data() {
        return {
        };
    },
    props: {
        requestedLoanProgramIds: {
            default: '1,3,6',
        },
        topLoanPrograms: {
            default: 3,
        },
        veteranStatusTypeId: {
            default: 3,
        },
        estimatedPurchasePrice: {
            default: 325000,
        },
        estimatedPropertyValue: {
            default: 300000,
        },
        estimatedDownPayment: {
            default: 50000,
        },
        currentMortgageBalance: {
            default: 250000,
        },
        loanType: {
            default: 1,
        },
        propertyTypeId: {
            default: 1,
        },
        estimatedCreditScoreBandId: {
            default: 2,
        },
        zipCode: {
            default: '',
        },
        estimatedFhaDownPayment: {
            default: 11375,
        },
        estimatedVaDownPayment: {
            default: 0,
        },
        requestedCashoutAmount: {
            default: 0,
        },
    },
};
